import { Tooltip, TooltipContent, TooltipTrigger } from 'cpool-components/general/Tooltip';

type Props = {
    bankLogo?: string | null;
    bankName?: string | null;
    description: string | null | undefined;
    imgClassName?: string;
};

export const BankLogoWithDescription: React.FC<Props> = ({ bankLogo, bankName, description, imgClassName }) => {
    const hasBankName = bankName != null && bankName.trim() !== '';
    const hasBankLogo = bankLogo != null && bankLogo.trim() !== '';

    const alt = `Bank Logo ${bankName}`;

    let logoElement: React.ReactNode;
    if (hasBankLogo) {
        logoElement = <img src={bankLogo} alt={alt} className={imgClassName} />;
    } else {
        logoElement = bankName ?? '';
    }

    let finalContent: React.ReactNode;
    if (hasBankName) {
        finalContent = (
            <Tooltip>
                {/* TooltipTrigger runs Children.only on its child, so the trigger has to stay a single
                    element: logoElement is a bare string when the bank has a name but no logo. */}
                <TooltipTrigger asChild>
                    <span>{logoElement}</span>
                </TooltipTrigger>
                <TooltipContent>{bankName}</TooltipContent>
            </Tooltip>
        );
    } else {
        finalContent = logoElement;
    }

    return (
        <>
            <div className="flex justify-center">{finalContent}</div>
            {description && <div className="mt-1 text-xs font-light">{description}</div>}
        </>
    );
};
